import { render } from "./Testing.vue?vue&type=template&id=07d860ab&scoped=true&ts=true"
import script from "./Testing.vue?vue&type=script&lang=ts"
export * from "./Testing.vue?vue&type=script&lang=ts"

import "./Testing.vue?vue&type=style&index=0&id=07d860ab&scoped=true&lang=css"
import "./Testing.vue?vue&type=style&index=1&id=07d860ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d860ab"]])

export default __exports__